module.exports = __webpack_public_path__ + "img/secondpic4.d559db57.png";